// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fO","seoBlockContent_visible":"c-a_fP"};